export const customScrollbar = {
    // Scrollbar for WebKit browsers
    "&::-webkit-scrollbar": {
        width: "8px",
    },
    "&::-webkit-scrollbar-track": {
        background: "#f1f1f1",
    },
    "&::-webkit-scrollbar-thumb": {
        background: "#888",
        borderRadius: "8px",
    },
    "&::-webkit-scrollbar-thumb:hover": {
        background: "#555",
    },
    // Scrollbar for Firefox
    scrollbarWidth: "thin",
    scrollbarColor: "#888 #f1f1f1",
};
